/* Nakama Clothing theme scripts (v2 redesign) */
(function () {
  'use strict';

  var money = function (cents) {
    if (window.NK && NK.formatMoney) return NK.formatMoney(cents);
    if (window.NK && NK.moneyFormat) {
      var v = (cents / 100).toFixed(2).replace('.', ',');
      return NK.moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, v);
    }
    return (cents / 100).toFixed(2) + ' €';
  };

  /* ---------- Add to cart (Horizon standard actions) ---------- */
  function addToCart(variantId, qty) {
    qty = qty || 1;
    if (window.Shopify && Shopify.actions && Shopify.actions.updateCart) {
      return Shopify.actions.updateCart({ lines: [{ merchandiseId: String(variantId), quantity: qty }] })
        .then(function (r) {
          if (r && r.userErrors && r.userErrors.length) throw new Error(r.userErrors[0].message);
          if (Shopify.actions.openCart) Shopify.actions.openCart();
          return r;
        });
    }
    return fetch((window.NK && NK.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.href = (window.NK && NK.routes.cart_url) || '/cart'; });
  }

  function addLines(lines) {
    if (lines.length === 1) return addToCart(lines[0].id, lines[0].qty);
    if (window.Shopify && Shopify.actions && Shopify.actions.updateCart) {
      return Shopify.actions.updateCart({ lines: lines.map(function (l) { return { merchandiseId: String(l.id), quantity: l.qty || 1 }; }) })
        .then(function (r) {
          if (r && r.userErrors && r.userErrors.length) throw new Error(r.userErrors[0].message);
          if (Shopify.actions.openCart) Shopify.actions.openCart();
          return r;
        });
    }
    return fetch((window.NK && NK.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines.map(function (l) { return { id: l.id, quantity: l.qty || 1 }; }) })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.href = (window.NK && NK.routes.cart_url) || '/cart'; });
  }

  function flashAdded(btn) {
    if (!btn) return;
    btn.classList.add('done'); btn.textContent = '✓';
    setTimeout(function () { btn.classList.remove('done'); btn.textContent = '+'; }, 1600);
  }

  /* ---------- Product cards: "+" quick add pop-up (Javier 29/09, like safe-stash) ---------- */
  /* Pair mode (05/10): cards with data-qa-cb-mode="pair" (no combo, accessory from custom.pairs_with) show the
     companion at full price: label pairLabel, no -10% pill, no struck price, button addBoth without saving. */
  var QA_T = {
    en: { pick: 'Choose your size', guide: 'Size guide', add: 'Add to cart', adding: 'Adding…', added: 'Added ✓', view: 'View product', close: 'Close', soldout: 'Sold out', cbLabel: 'Complete the look', pairLabel: 'Pair it with', addBoth: 'Add both', size: 'Size', both: 'Add both · save {x}', rec: 'Recommended', hintUp: 'from L up our hoodies fit slimmer than the tees, so we suggest one size up.', hintDown: 'from XL up our hoodies fit slimmer than the tees, so one size down is enough in the tee.', hintSameH: 'in S and M the hoodie is already roomy, take your usual size.', hintSameT: 'in S, M and L the tee matches your hoodie size.', hintMax: 'XXL is our biggest hoodie and it fits a bit slimmer than the XXL tee. Check the size guide.', sizeFor: 'Size for the {k}', kHoodie: 'hoodie', kTee: 't-shirt' },
    es: { pick: 'Elige tu talla', guide: 'Guía de tallas', add: 'Añadir al carrito', adding: 'Añadiendo…', added: 'Añadido ✓', view: 'Ver producto', close: 'Cerrar', soldout: 'Agotado', cbLabel: 'Completa el look', pairLabel: 'Combínalo con', addBoth: 'Añadir los dos', size: 'Talla', both: 'Añadir los dos · ahorras {x}', rec: 'Recomendada', hintUp: 'de la L en adelante las sudaderas son más estrechas que las camisetas, te recomendamos una talla más.', hintDown: 'de la XL en adelante las sudaderas son más estrechas que las camisetas, así que en camiseta te basta una talla menos.', hintSameH: 'en S y M la sudadera ya es holgada, coge tu misma talla.', hintSameT: 'en S, M y L la camiseta equivale a tu talla de sudadera.', hintMax: 'la XXL es nuestra sudadera más grande y es algo más estrecha que la camiseta XXL. Mira la guía de tallas.', sizeFor: 'Talla de la {k}', kHoodie: 'sudadera', kTee: 'camiseta' },
    fr: { pick: 'Choisis ta taille', guide: 'Guide des tailles', add: 'Ajouter au panier', adding: 'Ajout…', added: 'Ajouté ✓', view: 'Voir le produit', close: 'Fermer', soldout: 'Épuisé', cbLabel: 'Complète le look', pairLabel: 'Associe-le avec', addBoth: 'Ajouter les deux', size: 'Taille', both: 'Ajouter les deux · -{x}', rec: 'Conseillée', hintUp: 'à partir du L, nos sweats taillent plus ajusté que les t-shirts : on te conseille une taille au-dessus.', hintDown: 'à partir du XL, nos sweats taillent plus ajusté que les t-shirts : une taille en dessous suffit pour le t-shirt.', hintSameH: 'en S et M, le sweat est déjà ample : prends ta taille habituelle.', hintSameT: 'en S, M et L, le t-shirt correspond à ta taille de sweat.', hintMax: 'le XXL est notre plus grand sweat et il taille un peu plus ajusté que le t-shirt XXL. Regarde le guide des tailles.', sizeFor: 'Taille du {k}', kHoodie: 'sweat', kTee: 't-shirt' },
    it: { pick: 'Scegli la taglia', guide: 'Guida alle taglie', add: 'Aggiungi al carrello', adding: 'Aggiungo…', added: 'Aggiunto ✓', view: 'Vedi prodotto', close: 'Chiudi', soldout: 'Esaurito', cbLabel: 'Completa il look', pairLabel: 'Abbinalo a', addBoth: 'Aggiungi entrambi', size: 'Taglia', both: 'Aggiungi entrambi · risparmi {x}', rec: 'Consigliata', hintUp: 'dalla L in su le felpe vestono più strette delle magliette: ti consigliamo una taglia in più.', hintDown: 'dalla XL in su le felpe vestono più strette delle magliette: per la maglietta basta una taglia in meno.', hintSameH: 'in S e M la felpa è già comoda: prendi la tua taglia di sempre.', hintSameT: 'in S, M e L la maglietta corrisponde alla tua taglia di felpa.', hintMax: 'la XXL è la nostra felpa più grande e veste un po\' più stretta della maglietta XXL. Guarda la guida alle taglie.', sizeFor: 'Taglia della {k}', kHoodie: 'felpa', kTee: 'maglietta' },
    de: { pick: 'Wähle deine Größe', guide: 'Größentabelle', add: 'In den Warenkorb', adding: 'Wird hinzugefügt…', added: 'Hinzugefügt ✓', view: 'Zum Produkt', close: 'Schließen', soldout: 'Ausverkauft', cbLabel: 'Look komplett', pairLabel: 'Kombiniere es mit', addBoth: 'Beide hinzufügen', size: 'Größe', both: 'Beide hinzufügen · spare {x}', rec: 'Empfohlen', hintUp: 'ab L fallen unsere Hoodies schmaler aus als die T-Shirts: wir empfehlen eine Größe größer.', hintDown: 'ab XL fallen unsere Hoodies schmaler aus als die T-Shirts: beim T-Shirt reicht eine Größe kleiner.', hintSameH: 'in S und M fällt der Hoodie schon weit aus: nimm deine übliche Größe.', hintSameT: 'in S, M und L entspricht das T-Shirt deiner Hoodie-Größe.', hintMax: 'XXL ist unser größter Hoodie und fällt etwas schmaler aus als das XXL-T-Shirt. Sieh dir die Größentabelle an.', sizeFor: 'Größe für {k}', kHoodie: 'den Hoodie', kTee: 'das T-Shirt' }
  };
  var qaT = QA_T[(document.documentElement.lang || 'en').slice(0, 2).toLowerCase()] || QA_T.en;
  var qa = null, qaSel = null, qaBtn = null, qaY = 0, qaCb = null, qaCbSize = null, qaMainKind = '';
  var QA_SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'];
  function esc(x) { var d = document.createElement('div'); d.textContent = x || ''; return d.innerHTML; }
  function qaClose() {
    if (!qa) return;
    if (qa.close && qa.open) qa.close(); else qa.removeAttribute('open');
    document.documentElement.classList.remove('nk-qa-lock');
  }
  /* Combo companion: same size as the chosen one when it exists (tee + hoodie), otherwise M or the first in stock */
  function qaCbPick(any) {
    if (!qa || !qaCb) return null;
    var box = qa.querySelector('[data-qa-cb]');
    if (!any && !(box && box.checked)) return null;
    var ok = qaCb.vars.filter(function (v) { return v.avail; });
    if (qaCbSize) { var m = ok.filter(function (v) { return v.title === qaCbSize; })[0]; if (m) return m; }
    var rec = qaCbRec();
    return ok.filter(function (v) { return v.title === rec; })[0] || ok.filter(function (v) { return v.title === 'M'; })[0] || ok[0] || null;
  }
  /* Recommended companion size (Javier 29/09): hoodies fit slimmer than tees, so tee L -> hoodie XL and hoodie XL -> tee L */
  /* Fit rule from the supplier sheets (Javier 29/09): tee chest grows 5 cm per size, hoodie only 2 cm.
     Tee S/M -> same hoodie size; tee L and up -> one size up. Hoodie S/M/L -> same tee size; hoodie XL and up -> one size down. */
  function qaCbDir() {
    if (!qaCb) return '';
    if (qaMainKind === 'tshirt' && qaCb.kind === 'hoodie') return 'up';
    if (qaMainKind === 'hoodie' && qaCb.kind === 'tshirt') return 'down';
    return '';
  }
  function qaMainSize() { var on = qa && qa.querySelector('.nk-qa__opt.on span'); return on ? on.firstChild.textContent.trim() : ''; }
  function qaCbShift() {
    var d = qaCbDir(), i = QA_SIZES.indexOf(qaMainSize());
    if (!d || i < 0) return 0;
    if (d === 'up') return i >= QA_SIZES.indexOf('L') ? 1 : 0;
    return i >= QA_SIZES.indexOf('XL') ? -1 : 0;
  }
  function qaCbRec() {
    var size = qaMainSize();
    var i = QA_SIZES.indexOf(size);
    if (i < 0) return size;
    var titles = qaCb.vars.map(function (v) { return v.title; });
    var j = i + qaCbShift();
    while (j >= 0 && j < QA_SIZES.length && titles.indexOf(QA_SIZES[j]) < 0) j += qaCbShift() || 1;
    if (j < 0 || j >= QA_SIZES.length) return titles[qaCbShift() > 0 ? titles.length - 1 : 0];
    return QA_SIZES[j];
  }
  function qaUpdate() {
    if (!qa) return;
    var go = qa.querySelector('.nk-qa__add');
    var cbv = qaCbPick(true);
    var sz = qa.querySelector('[data-qa-cb-size]');
    if (sz && cbv) sz.textContent = cbv.title === 'Default Title' ? '' : qaT.size + ' ' + cbv.title;
    var pr = qa.querySelector('[data-qa-cb-price]');
    if (pr && cbv) pr.innerHTML = qaCb.pair ? money(cbv.cents) : '<i>-10%</i><s>' + money(cbv.cents) + '</s>' + money(cbv.cents - Math.round(cbv.cents / 10));
    var rec = qaCb ? qaCbRec() : '';
    qa.querySelectorAll('[data-cb-size]').forEach(function (c) {
      c.classList.toggle('on', !!cbv && c.dataset.cbSize === cbv.title);
      c.classList.toggle('rec', c.dataset.cbSize === rec && qaCbDir() !== '');
    });
    var hint = qa.querySelector('[data-qa-hint]');
    if (hint) {
      var sh = qaCbShift(), d = qaCbDir(), txt;
      if (sh > 0 && rec === qaMainSize()) txt = qaT.hintMax;
      else if (sh > 0) txt = qaT.hintUp;
      else if (sh < 0) txt = qaT.hintDown;
      else txt = d === 'up' ? qaT.hintSameH : qaT.hintSameT;
      hint.innerHTML = '<b>' + qaT.rec + ': ' + esc(rec) + '</b> · ' + txt;
    }
    var main = qa.querySelector('.nk-qa__opt.on');
    var box = qa.querySelector('[data-qa-cb]');
    if (qa.querySelector('.nk-qa__cb')) qa.querySelector('.nk-qa__cb').classList.toggle('on', !!(box && box.checked));
    if (!go || go.disabled && go.textContent === qaT.adding) return;
    if (box && box.checked && cbv && main && qaCb.pair) go.textContent = qaT.addBoth;
    else if (box && box.checked && cbv && main) {
      var save = Math.round(parseInt(main.dataset.cents, 10) / 10) + Math.round(cbv.cents / 10);
      go.textContent = qaT.both.replace('{x}', money(save));
    } else go.textContent = qaT.add;
  }
  function qaCbChips() {
    if (!qaCb || qaCb.vars.length < 2) return '';
    var cross = qaCbDir() !== '';
    var k = qaCb.kind === 'hoodie' ? qaT.kHoodie : qaT.kTee;
    var sgk = (qaCb.kind === 'hoodie' || qaCb.kind === 'tshirt') && document.getElementById('nk-size-guide') ? qaCb.kind : '';
    return '<div class="nk-qa__cbsz"><div class="nk-qa__cbszt"><span>' + qaT.sizeFor.replace('{k}', k) + '</span>' +
      (sgk ? '<a href="#" class="sg" data-nk-sg="' + sgk + '" data-nk-sg-tabs>' + qaT.guide + '</a>' : '') + '</div><div class="nk-qa__chips">' +
      qaCb.vars.map(function (v) { return '<button type="button" data-cb-size="' + esc(v.title) + '"' + (v.avail ? '' : ' disabled') + '>' + esc(v.title) + '</button>'; }).join('') +
      '</div>' + (cross ? '<p class="nk-qa__hint" data-qa-hint></p>' : '') + '</div>';
  }
  function qaOpen(pc, btn) {
    if (!qa) {
      qa = document.createElement('dialog');
      qa.className = 'nk nk-qa';
      qa.setAttribute('aria-labelledby', 'nk-qa-title');
      document.body.appendChild(qa);
      qa.addEventListener('click', function (e) {
        if (e.target === qa || e.target.closest('[data-qa-close]')) { qaClose(); return; }
        var chip = e.target.closest('[data-cb-size]');
        if (chip && !chip.disabled) {
          qaCbSize = chip.dataset.cbSize;
          var bx = qa.querySelector('[data-qa-cb]'); if (bx) bx.checked = true;
          qaUpdate();
          return;
        }
        var o = e.target.closest('.nk-qa__opt');
        if (o && !o.disabled) {
          qa.querySelectorAll('.nk-qa__opt').forEach(function (x) { x.classList.toggle('on', x === o); x.setAttribute('aria-checked', x === o); });
          qaSel = o.dataset.variant;
          qaCbSize = null;
          qaUpdate();
          return;
        }
        var go = e.target.closest('.nk-qa__add');
        if (go && qaSel) {
          var lines = [{ id: qaSel, qty: 1 }];
          var cbv = qaCbPick();
          if (cbv) lines.push({ id: cbv.id, qty: 1 });
          go.disabled = true; go.textContent = qaT.adding;
          addLines(lines).then(function () { go.textContent = qaT.added; flashAdded(qaBtn); setTimeout(qaClose, 450); })
            .catch(function (err) { alert(err.message || 'Error'); })
            .finally(function () { setTimeout(function () { go.disabled = false; qaUpdate(); }, 800); });
        }
      });
      qa.addEventListener('change', qaUpdate);
      qa.addEventListener('close', function () { document.documentElement.classList.remove('nk-qa-lock'); });
    }
    qaBtn = btn;
    var link = pc.querySelector('a.ph, a.txt');
    var sg = pc.dataset.qaSg && document.getElementById('nk-size-guide') ? pc.dataset.qaSg : '';
    var vs = Array.prototype.slice.call(pc.querySelectorAll('.picker [data-variant]'));
    var pick = vs.filter(function (b) { return !b.disabled && b.textContent.trim() === 'M'; })[0] || vs.filter(function (b) { return !b.disabled; })[0];
    qaSel = pick ? pick.dataset.variant : null;
    qaCb = null; qaCbSize = null; qaMainKind = pc.dataset.qaSg || '';
    if (pc.dataset.qaCbV) {
      qaCb = { title: pc.dataset.qaCbTitle, img: pc.dataset.qaCbImg, kind: pc.dataset.qaCbKind || '', pair: pc.dataset.qaCbMode === 'pair', vars: pc.dataset.qaCbV.split(';').map(function (x) { var a = x.split('|'); return { id: a[0], title: a[1], cents: parseInt(a[2], 10), avail: /^true$/i.test(a[3]) }; }) };
      if (!qaCb.vars.some(function (v) { return v.avail; })) qaCb = null;
    }
    var opts = vs.map(function (b) {
      var on = b === pick;
      return '<button type="button" role="radio" class="nk-qa__opt' + (on ? ' on' : '') + '" aria-checked="' + on + '" data-variant="' + b.dataset.variant + '" data-cents="' + (b.dataset.cents || 0) + '"' + (b.disabled ? ' disabled' : '') + '>' +
        '<span>' + esc(b.textContent.trim()) + (b.disabled ? ' <small>' + qaT.soldout + '</small>' : '') + '</span>' +
        '<b>' + (b.dataset.compare ? '<s>' + esc(b.dataset.compare) + '</s>' : '') + esc(b.dataset.price || '') + '</b></button>';
    }).join('');
    qa.innerHTML = '<div class="nk-qa__box">' +
      '<button type="button" class="nk-qa__x" data-qa-close aria-label="' + qaT.close + '">✕</button>' +
      '<div class="nk-qa__hd">' + (pc.dataset.qaImg ? '<img src="' + pc.dataset.qaImg + '" alt="" width="84" height="84">' : '') +
      '<div><span class="nk-qa__u">' + esc(pc.dataset.qaLabel) + '</span><h3 class="nk-qa__h" id="nk-qa-title">' + esc(pc.dataset.qaTitle).replace(/-/g, '‑') + '</h3></div></div>' +
      '<div class="nk-qa__t"><span>' + qaT.pick + '</span>' + (sg ? '<a href="#" class="sg" data-nk-sg="' + sg + '">' + qaT.guide + '</a>' : '') + '</div>' +
      '<div class="nk-qa__opts" role="radiogroup">' + opts + '</div>' +
      (qaCb ? '<div class="nk-qa__cbw"><label class="nk-qa__cb"><input type="checkbox" data-qa-cb><span class="nk-qa__chk" aria-hidden="true"></span>' +
        (qaCb.img ? '<img src="' + qaCb.img + '" alt="" width="52" height="52">' : '') +
        '<span class="nk-qa__cbt"><small>' + (qaCb.pair ? qaT.pairLabel : qaT.cbLabel) + '</small><b>' + esc(qaCb.title).replace(/-/g, '‑') + '</b><em data-qa-cb-size></em></span>' +
        '<span class="nk-qa__cbp" data-qa-cb-price></span></label>' + qaCbChips() + '</div>' : '') +
      '<button type="button" class="btn sun nk-qa__add"' + (qaSel ? '' : ' disabled') + '>' + qaT.add + '</button>' +
      (link ? '<a class="nk-qa__more" href="' + link.href + '">' + qaT.view + ' →</a>' : '') +
      '</div>';
    qaY = window.scrollY;
    if (qa.showModal) { if (!qa.open) qa.showModal(); } else qa.setAttribute('open', '');
    document.documentElement.classList.add('nk-qa-lock');
    if (window.scrollY !== qaY) window.scrollTo(0, qaY);
    qaUpdate();
    var first = qa.querySelector('.nk-qa__opt.on'); if (first) first.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('.pc .add');
    if (add) {
      e.preventDefault();
      var pc = add.closest('.pc');
      if (pc.querySelector('.picker [data-variant]')) {
        qaOpen(pc, add);
      } else {
        var vid = pc.dataset.variant;
        if (!vid) return;
        add.disabled = true;
        addToCart(vid, 1).then(function () { flashAdded(add); }).catch(function (err) { alert(err.message || 'Error'); })
          .finally(function () { add.disabled = false; });
      }
      return;
    }
    /* Whole card opens the product (Javier 29/09): photo, title, price or any empty space. Only "+" opens the pop-up. */
    var card = e.target.closest('.pc');
    if (card && !e.target.closest('a,button')) {
      var link = card.querySelector('a.ph, a.txt');
      if (link && link.href) {
        if (e.metaKey || e.ctrlKey) window.open(link.href, '_blank'); else window.location.href = link.href;
      }
    }
  });

  /* ---------- Header: cart, search, mobile menu ---------- */
  document.addEventListener('click', function (e) {
    /* Cart icon: goes to the cart page (Javier 30/09). The drawer only opens after adding a product. */
    if (e.target.closest('[data-nk-cart]')) return;
    var s = e.target.closest('[data-nk-search]');
    if (s) {
      var modal = document.getElementById('search-modal');
      if (modal && typeof modal.showDialog === 'function') { e.preventDefault(); modal.showDialog(); }
      return;
    }
    var m = e.target.closest('[data-nk-menu]');
    if (m) { e.preventDefault(); document.body.classList.toggle('nk-menu-open'); return; }
    var mc = e.target.closest('[data-nk-menu-close]');
    if (mc || (document.body.classList.contains('nk-menu-open') && e.target.classList.contains('nk-mnav'))) {
      document.body.classList.remove('nk-menu-open');
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') document.body.classList.remove('nk-menu-open'); });

  /* ---------- Product page ---------- */
  function initProduct() {
    var root = document.querySelector('[data-nk-product]');
    if (!root) return;
    var product = null;
    try { product = JSON.parse(root.querySelector('[data-nk-product-json]').textContent); } catch (err) { return; }

    /* gallery */
    var main = root.querySelector('#pd-main');
    var th = Array.prototype.slice.call(root.querySelectorAll('.thumbs button'));
    var idx = 0;
    function show(n) {
      if (!th.length) return;
      idx = (n + th.length) % th.length;
      var img = th[idx].querySelector('img');
      main.src = th[idx].dataset.src || img.src;
      main.alt = img.alt || '';
      th.forEach(function (t, k) { t.classList.toggle('on', k === idx); });
    }
    th.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var prev = root.querySelector('.gal .prev'), next = root.querySelector('.gal .next');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });

    /* variants */
    var form = root.querySelector('form[data-nk-form]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-nk-price]');
    var cmpEl = root.querySelector('[data-nk-compare]');
    var atc = root.querySelector('[data-nk-atc]');
    var szLabel = root.querySelector('[data-nk-size-label]');
    var opts = root.querySelectorAll('.opt');
    var selected = [];
    opts.forEach(function (o, i) {
      var on = o.querySelector('.sz.on');
      selected[i] = on ? on.dataset.value : null;
    });
    function findVariant() {
      return product.variants.find(function (v) {
        return selected.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }
    function update() {
      var v = findVariant();
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.firstChild.nodeValue = money(v.price) + ' ';
      if (cmpEl) { if (v.compare_at_price && v.compare_at_price > v.price) { cmpEl.textContent = money(v.compare_at_price); cmpEl.hidden = false; } else cmpEl.hidden = true; }
      if (atc) {
        atc.disabled = !v.available;
        atc.textContent = v.available ? atc.dataset.add : atc.dataset.soldout;
      }
      if (szLabel && selected[0]) szLabel.textContent = selected[0];
      opts.forEach(function (o, i) {
        o.querySelectorAll('.sz').forEach(function (b) {
          var test = selected.slice(); test[i] = b.dataset.value;
          var ok = product.variants.some(function (vv) { return vv.available && test.every(function (val, j) { return val === null || vv.options[j] === val; }); });
          b.classList.toggle('off', !ok);
        });
      });
      try { history.replaceState(null, '', location.pathname + '?variant=' + v.id); } catch (err) { }
    }
    opts.forEach(function (o, i) {
      o.addEventListener('click', function (e) {
        var b = e.target.closest('.sz'); if (!b) return;
        o.querySelectorAll('.sz').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on'); selected[i] = b.dataset.value; update();
      });
    });
    update();

    /* quantity */
    var qty = root.querySelector('.qty');
    if (qty) {
      var inp = qty.querySelector('input');
      qty.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        var n = parseInt(inp.value, 10) || 1;
        n = b.dataset.dir === 'down' ? Math.max(1, n - 1) : n + 1;
        inp.value = n;
      });
    }

    /* add to cart via drawer */
    form.addEventListener('submit', function (e) {
      if (e.submitter && e.submitter.name === 'checkout') return;
      e.preventDefault();
      var q = parseInt(form.querySelector('input[name="quantity"]').value, 10) || 1;
      atc.disabled = true; var t = atc.textContent; atc.textContent = atc.dataset.adding;
      addToCart(idInput.value, q).then(function () { atc.textContent = atc.dataset.added; })
        .catch(function (err) { alert(err.message || 'Error'); })
        .finally(function () { setTimeout(function () { atc.textContent = t; atc.disabled = false; }, 1500); });
    });
  }

  /* ---------- FAQ chips ---------- */
  function initFaq() {
    var chips = document.querySelector('.faq-chips'); if (!chips) return;
    chips.addEventListener('click', function (e) {
      var a = e.target.closest('.chip'); if (!a) return;
      e.preventDefault();
      chips.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('on'); });
      a.classList.add('on');
      var target = a.getAttribute('href');
      document.querySelectorAll('.fgroup').forEach(function (g) {
        g.style.display = (target === '#all' || ('#' + g.id) === target) ? '' : 'none';
      });
    });
  }

  /* ---------- Recommendations ---------- */
  function initRecs() {
    document.querySelectorAll('[data-nk-recs]').forEach(function (el) {
      var url = el.dataset.nkRecs;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('[data-nk-recs-inner]');
        if (inner && inner.children.length) { el.querySelector('[data-nk-recs-inner]').innerHTML = inner.innerHTML; el.hidden = false; }
      }).catch(function () { });
    });
  }

  /* ---------- Localization selects ---------- */
  function initLocalization() {
    document.querySelectorAll('form#nk-localization select').forEach(function (sel) {
      sel.addEventListener('change', function () { sel.form.submit(); });
    });
  }

  /* ---------- Cart perks: free shipping + gift box (Javier 30/09) ----------
     Markup and texts: snippets/nk-cart-perks.liquid (inside the cart drawer and the cart page).
     Thresholds come in EUR cents and are converted to the customer's currency here. */
  var PERK_BUSY = false;
  function perkRate(cur) {
    if (!cur || cur === 'EUR') return 1;
    var c = window.Shopify && Shopify.currency;
    var r = c && c.active === cur ? parseFloat(c.rate) : NaN;
    return isFinite(r) && r > 0 ? r : 1;
  }
  function perkMoney(cents, cur, whole) {
    if (window.NK && NK.formatMoney && (!cur || cur === NK.currency)) return NK.formatMoney(cents, whole);
    var lang = (document.documentElement.lang || 'es').replace('_', '-');
    try {
      return new Intl.NumberFormat(lang, { style: 'currency', currency: cur || 'EUR',
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(whole ? 0 : 2) + ' ' + (cur || 'EUR'); }
  }
  function perkKeys(el) { return (el.dataset.giftKeys || '').split(',').filter(Boolean); }

  /* Re-render the Horizon cart sections (drawer and cart page) after a change made here */
  function perkRefresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (cart) {
        return import('@shopify/events').then(function (m) {
          var E = m.CartLinesUpdateEvent;
          var d = E.createPromise();
          document.dispatchEvent(new E({ action: 'update', context: 'cart', lines: [], promise: d.promise }));
          d.resolve({ cart: E.createCartFromAjaxResponse(cart), detail: { items: cart.items, itemCount: cart.item_count, source: 'nk-perks', didError: false } });
        });
      })
      .catch(function () { window.location.reload(); });
  }
  function perkUpdate(updates) {
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }) });
  }

  /* Mark the gift box line (no quantity, no delete, "Gift · Free" tag); Horizon renders the rows */
  function markGiftRows(el) {
    perkKeys(el).forEach(function (k) {
      document.querySelectorAll('.cart-items__table-row[data-key="' + k + '"]').forEach(function (row) {
        if (!row.hasAttribute('data-nk-gift')) row.setAttribute('data-nk-gift', '');
        var tr = row.querySelector('.cart-items__title-row');
        if (tr && !tr.querySelector('.nk-gift-tag')) {
          var t = document.createElement('span'); t.className = 'nk-gift-tag'; t.textContent = el.dataset.tTag || 'Gift';
          tr.appendChild(t);
        }
      });
    });
  }

  function renderPerks(el) {
    markGiftRows(el);
    var total = parseInt(el.dataset.total, 10) || 0, cur = el.dataset.cur || 'EUR';
    var keys = perkKeys(el), qty = parseInt(el.dataset.giftQty, 10) || 0;
    var sig = [total, cur, keys.join(','), qty].join('|');
    if (el.dataset.nkDone === sig) return;
    el.dataset.nkDone = sig;

    var rate = perkRate(cur);
    var ship = Math.round((parseInt(el.dataset.ship, 10) || 7500) * rate / 100) * 100;
    var gift = Math.round((parseInt(el.dataset.gift, 10) || 10000) * rate / 100) * 100;
    var pct = total < ship ? total / ship * 50 : 50 + Math.min((total - ship) / Math.max(gift - ship, 1), 1) * 50;
    var q = function (s) { return el.querySelector(s); };
    q('[data-fill]').style.width = Math.max(0, Math.min(100, pct)) + '%';
    q('[data-m-ship]').classList.toggle('on', total >= ship);
    q('[data-m-gift]').classList.toggle('on', total >= gift);
    q('[data-l-ship]').textContent = perkMoney(ship, cur, true);
    q('[data-l-gift]').textContent = perkMoney(gift, cur, true);
    var msg = total < ship ? el.dataset.tShipLeft.replace('{x}', '<b>' + perkMoney(ship - total, cur) + '</b>')
      : total < gift ? el.dataset.tGiftLeft.replace('{x}', '<b>' + perkMoney(gift - total, cur) + '</b>')
      : '<b>' + el.dataset.tDone + '</b>';
    q('[data-msg]').innerHTML = msg;
    q('[data-claim]').hidden = !(total >= gift && keys.length === 0);
    q('[data-have]').hidden = !(total >= gift && keys.length > 0);

    /* Keep the gift honest: remove it below the threshold, and never more than one box */
    if (PERK_BUSY || !keys.length) return;
    var updates = null;
    if (total < gift) { updates = {}; keys.forEach(function (k) { updates[k] = 0; }); }
    else if (keys.length > 1 || qty > 1) { updates = {}; keys.forEach(function (k, i) { updates[k] = i === keys.length - 1 ? 1 : 0; }); }
    if (!updates) return;
    PERK_BUSY = true;
    perkUpdate(updates).then(perkRefresh).finally(function () { PERK_BUSY = false; });
  }
  function renderAllPerks() { document.querySelectorAll('[data-nk-perks]').forEach(renderPerks); }

  /* Gift box chooser (pop-up over the drawer) */
  function openGiftModal(el) {
    var boxes = [];
    try { boxes = JSON.parse(el.querySelector('[data-nk-boxes]').textContent) || []; } catch (e) { }
    boxes = boxes.filter(function (b) { return b && b.v && b.a; });
    if (!boxes.length) return;
    var current = (el.dataset.giftVars || '').split(',').filter(Boolean);
    var dlg = document.createElement('dialog');
    dlg.className = 'nk-gift';
    dlg.innerHTML = '<div class="nk-gift__box"><button type="button" class="nk-gift__x" aria-label="' + el.dataset.tClose + '">✕</button>' +
      '<h3 class="nk-gift__h">' + el.dataset.tModal + '</h3><p class="nk-gift__s">' + el.dataset.tModalS + '</p><div class="nk-gift__grid">' +
      boxes.map(function (b) {
        var on = current.indexOf(String(b.v)) > -1;
        return '<button type="button" class="nk-gift__it' + (on ? ' on' : '') + '" data-v="' + b.v + '">' +
          (b.img ? '<img src="' + b.img + '" alt="" loading="lazy" width="180" height="180">' : '<span class="nk-gift__ph"></span>') +
          '<b>' + b.t.replace(/</g, '&lt;') + '</b><span class="nk-gift__pick">' + (on ? '✓' : el.dataset.tPick) + '</span></button>';
      }).join('') + '</div>' + (el.dataset.tStock ? '<p class="nk-gift__note">' + el.dataset.tStock + '</p>' : '') + '</div>';
    document.body.appendChild(dlg);
    var close = function () { if (dlg.open) dlg.close(); };
    dlg.addEventListener('close', function () { dlg.remove(); });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('.nk-gift__x')) { close(); return; }
      var it = e.target.closest('.nk-gift__it'); if (!it || dlg.dataset.busy) return;
      var v = it.dataset.v;
      if (current.indexOf(v) > -1) { close(); return; }
      dlg.dataset.busy = '1'; it.querySelector('.nk-gift__pick').textContent = el.dataset.tAdding;
      var old = perkKeys(el);
      PERK_BUSY = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(v), quantity: 1, properties: { _gift_100_meta: 'true' } }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); })
        .then(function () { if (!old.length) return; var u = {}; old.forEach(function (k) { u[k] = 0; }); return perkUpdate(u); })
        .then(perkRefresh)
        .then(close)
        .catch(function () { delete dlg.dataset.busy; it.querySelector('.nk-gift__pick').textContent = el.dataset.tPick; })
        .finally(function () { PERK_BUSY = false; });
    });
    dlg.showModal();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-nk-gift-open]'); if (!b) return;
    var el = b.closest('[data-nk-perks]'); if (!el) return;
    e.preventDefault(); openGiftModal(el);
  });
  /* Horizon morphs the cart after every change: re-apply the numbers whenever the perks box is touched */
  var perkTimer;
  new MutationObserver(function () { clearTimeout(perkTimer); perkTimer = setTimeout(renderAllPerks, 30); })
    .observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-total', 'data-gift-keys', 'data-nk-done'] });

  function init() { initProduct(); initFaq(); initRecs(); initLocalization(); renderAllPerks(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
